export default __webpack_public_path__ + "5cb91e699b1f35ab0481fbf99ebd89a7.svg";